const defaultYearOptions = {
    default: {
        // 2021
        year: "numeric",
    },
};
export { defaultYearOptions };
